import { FormControlLabel, Theme, styled } from '@material-ui/core';

export const StyledCheckboxFormControlLabel = styled(FormControlLabel)({
  marginLeft: '-0.9rem',
});

export const StyledUnCheckedIcon = styled('div')<Theme>(({ theme }) => ({
  position: 'relative',
  display: 'block',
  width: '2rem',
  height: '2rem',
  border: theme.config.defaultBorder(),
  borderRadius: theme.config.defaultBorderRadius,
  boxShadow: theme.config.defaultBoxShadow,
}));

export const StyledCheckedIcon = styled('div')<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '0.8rem',
  left: '0.5rem',
  display: 'block',
  transform: 'rotate(45deg)',
  '&:before': {
    display: 'block',
    content: '',
    position: 'absolute',
    width: '0.3rem',
    height: '0.3rem',
    backgroundColor: theme.palette.primary.main,
    top: 0,
    left: 0,
  },
  '&:after': {
    display: 'block',
    content: '',
    position: 'absolute',
    width: '0.3rem',
    height: '1.1rem',
    left: '0.3rem',
    top: '-0.8rem',
    backgroundColor: theme.palette.primary.main,
  },
}));

export const Opacity50Wrapper = styled('span')({
  opacity: '0.5',
});
